import React from 'react';

import * as PolicyDAO from 'auth/PolicyDAO';
import BenchlingConfig from 'BenchlingConfig';

import EmptySidebarIcon from './EmptySidebarIcon';
import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface PolicySettingsProps {
  section: SidebarConstants.Section;
}

export default function PolicySettings(props: PolicySettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Permissions Settings</div>
      <SidebarItem
        active={props.section === SidebarConstants.Section.DATA_POLICIES}
        icon={<EmptySidebarIcon />}
        name={
          BenchlingConfig.PERMISSIONS_ENABLE_SCHEMA_POLICY_CONFIGURATION
            ? 'General access policies'
            : 'Access policies'
        }
        link={PolicyDAO.getDataPoliciesURL()}
      />
      {BenchlingConfig.PERMISSIONS_ENABLE_SCHEMA_POLICY_CONFIGURATION && (
        <SidebarItem
          active={props.section === SidebarConstants.Section.SCHEMA_POLICIES}
          icon={<EmptySidebarIcon />}
          name="Schema access policies"
          link={PolicyDAO.getSchemaPoliciesURL()}
        />
      )}
    </div>
  );
}
